<template>
  <el-select
    size="mini"
    placeholder="Filtrar por vendedor"
    v-bind:value="seller"
    filterable
    clearable
    @change="handleChange"
    v-bind="$attrs"
    :rules="[{ required: true, message: 'Vendedor requerido' }]"
  >
    <el-option
      v-for="(seller, index) in sellerList"
      :key="index"
      :value="seller.value"
      :label="seller.label"
    >
      <el-avatar
        v-if="seller.image"
        style="float: left"
        size="small"
        :src="seller.image"
      ></el-avatar>
      <el-avatar
        v-else
        style="float: left"
        size="small"
        src="/static/images/avatar-2.jpg"
      ></el-avatar>
      <span style="padding-left: 5px; color: #8492a6; font-size: 12px">{{
        seller.label
      }}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  model: {
    prop: "seller",
    event: "change"
  },
  props: {
    seller: {
      type: [Number, String],
      required: false,
      default: null
    }
  },
  computed: {
    sellerList() {
      return this.$store.getters["sellers/getSellersEmployee"];
    },
    personCodeFromStore() {
      const code = this.$store.state.user.user?.PersonCode ?? null;
      if (code === null) return null;
      const n = parseInt(code, 10);
      return Number.isNaN(n) ? code : n;
    }
  },
  methods: {
    getSeller(id) {
      return this.$store.getters["sellers/getSellerById"](id);
    },
    handleChange(val) {
      // this.$emit("update:seller", val);
      this.$emit("change", val);
      const seller = this.getSeller({ id: val });
      this.$emit("selected-seller", seller);
    }
  },
  mounted() {
    if (!this.seller && this.personCodeFromStore) {
      this.handleChange(this.personCodeFromStore);
    }
  }
};
</script>
